import {FC, useState} from 'react'
import InputMask from 'react-input-mask'
import styles from './Input.module.css'
import IntlCurrencyInput from 'react-intl-currency-input'
import Select from 'react-select'
import {MyTooltip} from '../ToolTip/ToolTip'
import {removeEspacosEmBranco} from '../../utils/formater'
import SVG from 'react-inlinesvg'
import {Button} from '../Button/Button'
import {i18n} from '../../translate/i18n'
import ReactLoading from 'react-loading'
import {POST} from '../../services/api'
import {ImageUpload} from '../ImageUpload/ImageUpload'
import {ImageUploadEdit} from '../ImageUpload/ImagemUploadEdit'

type GenerateIAType = {
  modelId: string
  prompt: string
  action: 'fix' | 'create'
}

type Props = {
  icon?: JSX.Element
  label?: string
  getFieldProps?: any
  inputAttr?: any
  checked?: boolean
  disabled?: boolean
  checkSwift?: boolean
  options?: any
  value?: any
  change?: any
  placeholder?: string
  maxLength?: string
  minLength?: string
  minNumber?: number
  maxNumber?: number
  textToSlider?: string
  textToMinNumber?: string
  textToMaxNumber?: string
  colorBefore?: string
  colorAfter?: string
  rows?: number
  maxCaracteres?: number
  currency?: string
  locale?: string
  isSecure?: boolean
  autoComplete?: string
  name?: string
  defaultValue?: string
  focus?: boolean
  smalltext?: string
  acceptFile?: string
  blur?: (value: string) => void
  onKeyDown?: (value: string) => void
  onAction?: () => void
  search?: boolean
  textCenter?: boolean
  size?: string
  id?: string
  toolTip?: boolean
  toolTiptext?: string
  toolTipIcon?: string
  toolTipLink?: string
  imagemBackgroundDefault?: string
  height?: string
  width?: string
  vertical?: boolean
  backgroundColor?: string
  objectFit?: 'cover' | 'contain' | 'fill' | 'none' | 'scale-down'
  imageBackgroundColor?: string
  idInput?: string
  alarm?: boolean
  alarmText?: string
  action?: () => void
  isMulti?: boolean
  generateValueIA?: GenerateIAType
  marginTop?: string
  paddingLeft?: string
  secret?: boolean
  grow?: boolean
  onlyLetters?: boolean
  removeImage?: boolean
  iconImage?: string
  mainTextImage?: string
  descriptionImage?: string
  sizeImage?: string
  dragAndDropImage?: boolean
  verticalAlign?: boolean
  maxFiles?: number
  showCheckbox?: boolean
  checkedCheckbox?: boolean
  onChangeCheckbox?: (checked: boolean) => void
  required?: boolean

  setImagesToDelete?: (value: any[]) => void
  imagesToDelete?: any[]
}

const Input: FC<Props> = (props) => {
  const {
    icon,
    disabled,
    label,
    getFieldProps,
    inputAttr,
    checked,
    options,
    value,
    change,
    placeholder,
    minLength,
    maxLength,
    checkSwift,
    minNumber,
    maxNumber,
    textToSlider,
    textToMinNumber,
    textToMaxNumber,
    colorBefore,
    colorAfter,
    rows,
    maxCaracteres,
    currency,
    locale,
    isSecure = true,
    autoComplete,
    name,
    defaultValue,
    focus,
    smalltext,
    acceptFile,
    blur,
    onKeyDown,
    search,
    textCenter,
    size,
    id,
    toolTip,
    toolTipIcon,
    toolTiptext,
    toolTipLink,
    imagemBackgroundDefault,
    height,
    width,
    vertical,
    onAction,
    backgroundColor,
    objectFit = 'cover',
    imageBackgroundColor,
    idInput,
    alarm,
    alarmText,
    action,
    isMulti,
    generateValueIA,
    marginTop,
    paddingLeft,
    secret,
    grow,
    onlyLetters = false,
    removeImage,
    iconImage,
    mainTextImage,
    descriptionImage,
    sizeImage,
    dragAndDropImage,
    verticalAlign,
    maxFiles,
    showCheckbox = false,
    checkedCheckbox,
    onChangeCheckbox,
    setImagesToDelete,
    imagesToDelete,
    required,
  } = props

  const [hiddenPassword, setHiddenPassword] = useState<boolean>(isSecure)
  const [loadingButton, setLoadingButton] = useState(false)
  const [secretFieldValue, setSecretFieldValue] = useState<string>('')
  const [isFieldFocused, setIsFieldFocused] = useState(false)

  const [maskTelephone, setMaskTelephone] = useState('(99) 9999-9999')

  // Função para criar máscara de campo sensível
  const createSecretMask = (value: string): string => {
    if (!value || value.length <= 4) {
      return value
    }

    const firstTwo = value.substring(0, 2)
    const lastTwo = value.substring(value.length - 2)
    const middleLength = value.length - 4
    const middleMask = '*'.repeat(middleLength)

    return `${firstTwo}${middleMask}${lastTwo}`
  }

  // Determina qual valor exibir - sempre com máscara se for secret
  const getDisplayValue = (): string => {
    if (!secret) {
      return value || ''
    }

    // Se está editando, mostra o que está sendo digitado
    if (secretFieldValue) {
      return secretFieldValue
    }

    // Se tem valor original, mostra com máscara
    if (value) {
      return createSecretMask(value)
    }

    return ''
  }

  function changePhone(newPhone: string, newValue: string) {
    // Remove tudo que não for número
    const digits = newPhone.concat(newValue).replace(/\D/g, '')
    if (digits.length >= 11) {
      setMaskTelephone('(99) 99999-9999')
    } else {
      setMaskTelephone('(99) 9999-9999')
    }
  }

  const generateTextIA = async () => {
    try {
      if (generateValueIA) {
        const result = await POST('structure-correction-ia/converse-structure', {
          prompt: generateValueIA.prompt,
          modelId: generateValueIA.modelId,
          systemPrompt:
            generateValueIA.action === 'fix'
              ? `Correct the provided product name by following these rules strictly and without exceptions:

                  STRICT RULES (MUST BE STRICTLY FOLLOWED):
                  1. Do not add, remove, translate, or invent any word.
                  2. Correct each word individually, strictly within its original language (English or Brazilian Portuguese).
                  3. If a word is originally in English, correct it in English and keep it in English.
                  4. If a word is originally in Brazilian Portuguese, correct it in Portuguese and keep it in Portuguese.
                  5. DO NOT translate any word from one language to another.
                  6. The number of words in the corrected result must be exactly the same as in the original name.
                  7. Return ONLY the corrected product name. Do not include explanations, punctuation, or any additional text.

                  Output format: Only the corrected product name, plain and clean.
                `.trim()
              : 'Criar o texto',
          typeCorrectionStructure:
            generateValueIA.action === 'fix' ? 'revision-structure' : 'description-structure',
        })
        if (result && result.message && result.message.data) {
          change(result.message.data)
        }
      }
    } catch (e) {
      console.log(e)
    }
  }

  const onlyLettersInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    let newValue = event.target.value

    newValue = newValue.replace(/[^a-zA-ZÀ-ÿ0-9\s]/g, '')

    if (/^\d+$/.test(newValue)) {
      return
    }

    if (change) {
      change(newValue)
    }
  }

  // Handlers específicos para campos secret
  const handleSecretChange = (newValue: string) => {
    setSecretFieldValue(newValue)

    // Se o usuário digitou algo, atualiza o valor real
    if (newValue.trim()) {
      change(newValue)
    }
  }

  const handleSecretFocus = () => {
    setIsFieldFocused(true)
    // Quando focar, limpa o campo para permitir nova digitação
    setSecretFieldValue('')
  }

  const handleSecretBlur = (event: any) => {
    setIsFieldFocused(false)
    const currentValue = event.target.value

    // Se o usuário não digitou nada, mantém o valor original
    if (!currentValue.trim() && value) {
      setSecretFieldValue('')
    } else if (currentValue.trim()) {
      // Se digitou algo, salva o novo valor
      change(currentValue)
      setSecretFieldValue('')
    }

    if (blur) {
      blur(currentValue || value)
    }
  }

  switch (inputAttr.type) {
    case 'radio':
      return (
        <div>
          <label className='d-flex align-items-center'>
            <input
              {...getFieldProps}
              {...inputAttr}
              checked={checked}
              onChange={(event) => change(event.target.checked)}
              name={name ? name : ''}
            />
            {icon}
            <span className='btn btn-sm btn-color-muted btn-active btn-active-primary ps-2 pe-4 py-0'>
              {label}
            </span>
          </label>
        </div>
      )
    case 'radio-button':
      return (
        <div className='mt-4'>
          {label && <label className='form-label fw-normal'>{label}</label>}
          <div className='d-flex justify-content-between gap-3'>
            {options &&
              options.map((opt: any) => (
                <button
                  key={opt.value}
                  type='button'
                  className={`btn ${
                    value === opt.value ? 'btn-primary text-white' : 'btn-light'
                  } fw-bold px-4 py-2 w-100`}
                  onClick={() => change(opt.value)}
                  disabled={disabled}
                >
                  {opt.label}
                </button>
              ))}
          </div>
        </div>
      )
    case 'newRadio':
      return (
        <div>
          <div className='mt-4'>
            <label className={`form-check d-flex align-items-center`}>
              <input
                {...getFieldProps}
                {...inputAttr}
                type='radio'
                className={`${styles.form_check_input}`}
                value={value}
                checked={checked}
                disabled={disabled}
                onChange={(event) => change(event.target.checked)}
              />
              <span className='px-2 py-0 form-check-label'>{label}</span>
            </label>
          </div>
        </div>
      )

    case 'newRadioModal':
      return (
        <div>
          <div className='mt-4'>
            <label className={`d-flex align-items-center`}>
              <input
                {...getFieldProps}
                {...inputAttr}
                type='radio'
                className={`${styles.form_check_input_xx}`}
                value={value}
                name={name}
                checked={checked}
                disabled={disabled}
                onChange={(event) => change(event.target.value)}
              />
              <span className='px-2 py-0 form-check-label'>{label}</span>
            </label>
          </div>
        </div>
      )
    case 'newRadioAgregador':
      return (
        <div className='mt-4'>
          <label className={`form-check d-flex align-items-center ${paddingLeft ? 'ps-0' : ''}`}>
            <input
              {...getFieldProps}
              {...inputAttr}
              type='radio'
              className={`${styles.form_check_input_agregador}`}
              value={value}
              checked={checked}
              disabled={disabled}
              name={name}
              onChange={(event) => change(event.target.value)}
            />
            <span className='px-2 py-0 form-check-label'>{label}</span>
          </label>
        </div>
      )
    case 'checkbox':
      return (
        <div className={`${marginTop ? marginTop : 'mt-4'}`}>
          {/* eslint-disable eqeqeq */}
          <label
            className={`form-check d-flex align-items-center gap-1 ${
              checkSwift && 'form-switch form-check-custom form-check-solid'
            } ${size && `switch-${size}`}
              ${
                vertical != undefined && vertical
                  ? 'd-flex  align-items-start flex-column-reverse gap-3'
                  : ''
              }
              `}
          >
            <input
              {...getFieldProps}
              {...inputAttr}
              // eslint-disable-next-line eqeqeq
              className={`form-check-input ${vertical !== undefined && vertical ? 'ms-2' : ''}`}
              value={value}
              defaultChecked={checked}
              disabled={disabled}
              onChange={(event) => change(event.target.checked)}
            />
            <span
              className={`form-check-label ${
                // eslint-disable-next-line eqeqeq
                checkSwift
                  ? `fw-normal text-gray-800  ${vertical != undefined && vertical ? '' : 'ms-5'}`
                  : 'fw-normal text-gray-800 ms-1'
              } ${toolTip ? 'd-flex' : ''}`}
            >
              {label}
              {toolTip && <MyTooltip text={toolTiptext!} icon={toolTipIcon} link={toolTipLink} />}
            </span>
          </label>
          {/* eslint-enable eqeqeq */}
        </div>
      )
    case 'checkbox-variation':
      return (
        <div className='mt-4'>
          <label
            className={`form-check d-flex align-items-center gap-1 ${
              checkSwift && 'form-switch form-check-custom form-check-solid'
            } ${size && `switch-${size}`}
              ${
                // eslint-disable-next-line eqeqeq
                vertical != undefined && vertical
                  ? 'd-flex  align-items-start flex-column-reverse gap-3'
                  : ''
              }
              `}
          >
            <input
              {...getFieldProps}
              {...inputAttr}
              type='checkbox'
              // eslint-disable-next-line eqeqeq
              className={`form-check-input ${vertical !== undefined && vertical ? 'ms-2' : ''}`}
              value={value}
              checked={checked}
              disabled={disabled}
              onChange={(event) => change(event.target.checked)}
            />
            <span
              className={`form-check-label ${
                checkSwift
                  ? // eslint-disable-next-line eqeqeq
                    `fw-normal text-gray-800  ${vertical != undefined && vertical ? '' : 'ms-5'}`
                  : 'fw-normal text-gray-800 ms-1'
              } ${toolTip ? 'd-flex' : ''}`}
            >
              {label}
              {toolTip && <MyTooltip text={toolTiptext!} icon={toolTipIcon} link={toolTipLink} />}
            </span>
          </label>
        </div>
      )
    case 'select':
      return (
        <div className={`${marginTop ? marginTop : 'mt-6'} flex-grow-1`}>
          {label && (
            <label
              className={`form-label fw-normal ${required ? 'required' : ''}`}
              style={{display: 'inline-flex', alignItems: 'center', gap: 6}}
            >
              {label}
              {toolTip && <MyTooltip text={toolTiptext!} icon={toolTipIcon} link={toolTipLink} />}
            </label>
          )}
          <div style={{border: alarm ? '1px solid #d90429' : 'none', borderRadius: '0.5rem'}}>
            {search ? (
              <Select
                styles={{
                  valueContainer: (provided, state) => ({
                    ...provided,
                    height: '30px',
                  }),
                }}
                closeMenuOnSelect={true}
                value={value}
                isMulti={isMulti}
                onChange={(event) => change(event)}
                placeholder={placeholder ? placeholder : 'Selecione uma opção'}
                options={options.map((option: any) => ({
                  value: option.value,
                  label: option.select,
                }))}
                isDisabled={disabled ? disabled : false}
              />
            ) : (
              <select
                className='form-select fw-normal ps-4 pe-12 border border-hover-primary'
                style={smalltext ? {marginBottom: '0.5rem'} : {}}
                data-kt-select2='true'
                data-placeholder='Select option'
                data-allow-clear='true'
                value={value}
                defaultValue={defaultValue}
                disabled={disabled ? disabled : false}
                onChange={(event) => change(event.target.value)}
                id={idInput ? idInput : label ? label.toLowerCase().replace(' ', '-') : ''}
              >
                {options.map((option: any) => (
                  <option key={option.key ? option.key : option.value} value={option.value}>
                    {option.select}
                  </option>
                ))}
              </select>
            )}
            {smalltext && <small className='mt-2'>{smalltext}</small>}
          </div>
          {alarm && <p className='mt-1 text-danger'>{alarmText ? alarmText : 'Campo faltante'}</p>}
        </div>
      )

    case 'select-mult-v2':
      return (
        <div className={`${marginTop ? marginTop : 'mt-6'} flex-grow-1`}>
          {label && (
            <label
              className='form-label fw-normal'
              style={{display: 'inline-flex', alignItems: 'center', gap: 6}}
            >
              {label}
              {toolTip && <MyTooltip text={toolTiptext!} icon={toolTipIcon} link={toolTipLink} />}
            </label>
          )}
          <div style={{border: alarm ? '1px solid #d90429' : 'none', borderRadius: '0.5rem'}}>
            <Select
              styles={{
                valueContainer: (provided, state) => ({
                  ...provided,
                  height: '30px',
                  flexWrap: 'wrap',
                  maxHeight: 80,
                  overflowY: 'auto',
                }),
                multiValue: (provided, state) => ({
                  ...provided,
                  maxWidth: '100%',
                  whiteSpace: 'normal',
                }),
                control: (provided, state) => ({
                  ...provided,
                  minHeight: '38px',
                  border: '1px solid #e4e6ef',
                  '&:hover': {
                    borderColor: '#009ef7',
                  },
                }),
              }}
              closeMenuOnSelect={false}
              value={value}
              isMulti={true}
              onChange={(event) => change(event)}
              placeholder={placeholder ? placeholder : 'Selecione uma ou mais opções'}
              options={options.map((option: any) => ({
                value: option.value,
                label: option.select,
              }))}
              isDisabled={disabled ? disabled : false}
            />
            {smalltext && <small className='mt-2'>{smalltext}</small>}
          </div>
          {alarm && <p className='mt-1 text-danger'>{alarmText ? alarmText : 'Campo faltante'}</p>}
        </div>
      )
    case 'select_small':
      return (
        <div className={`${vertical ? 'd-flex gap-2 align-items-center mt-2' : ''}`}>
          {label && <label className='form-label fw-normal'>{label}</label>}
          <div>
            {search ? (
              <Select
                styles={{
                  control: (provided: any, state: any) => ({
                    ...provided,
                    padding: 2,
                    border: '1px solid #e4e6ef',
                  }),
                }}
                value={value}
                onChange={(event) => change(event)}
                placeholder={placeholder ? placeholder : 'Selecione uma opção'}
                options={options.map((option: any) => ({
                  value: option.value,
                  label: option.select,
                }))}
                isDisabled={disabled ? disabled : false}
              />
            ) : (
              <select
                className='form-select fw-normal ps-4 pe-12 border border-hover-primary'
                data-kt-select2='true'
                data-placeholder='Select option'
                data-allow-clear='true'
                value={value}
                defaultValue={defaultValue}
                disabled={disabled ? disabled : false}
                onChange={(event) => change(event.target.value)}
              >
                {options.map((option: any) => (
                  <option key={option.key ? option.key : option.value} value={option.value}>
                    {option.select}
                  </option>
                ))}
              </select>
            )}
          </div>
        </div>
      )
    case 'select-publicidade':
      return (
        <div>
          {label && <label className='form-label fw-normal'>{label}</label>}
          <div>
            {search ? (
              <Select
                styles={{
                  control: (provided: any, state: any) => ({
                    ...provided,
                    padding: 2,
                    border: '1px solid #e4e6ef',
                  }),
                }}
                value={value}
                onChange={(event) => change(event)}
                placeholder={placeholder ? placeholder : 'Selecione uma opção'}
                options={options.map((option: any) => ({
                  value: option.value,
                  label: option.select,
                }))}
                isDisabled={disabled ? disabled : false}
              />
            ) : (
              <select
                className='form-select fw-normal ps-4 pe-12 border border-hover-primary'
                data-kt-select2='true'
                data-placeholder='Select option'
                data-allow-clear='true'
                value={value}
                defaultValue={defaultValue}
                disabled={disabled ? disabled : false}
                onChange={(event) => change(event.target.value)}
              >
                {options.map((option: any) => (
                  <option key={option.key ? option.key : option.value} value={option.value}>
                    {option.select}
                  </option>
                ))}
              </select>
            )}
          </div>
        </div>
      )
    case 'select-agregador':
      return (
        <div className='mt-6 d-flex gap-2 align-items-center'>
          {label && <label className='form-label fw-normal'>{label}</label>}
          <div>
            <select
              className={`form-select ${styles.form_select_little}`}
              data-kt-select2='true'
              data-placeholder='Select option'
              data-allow-clear='true'
              value={value}
              defaultValue={defaultValue}
              disabled={disabled ? disabled : false}
              onChange={(event) => change(event.target.value)}
            >
              {options.map((option: any) => (
                <option key={option.key ? option.key : option.value} value={option.value}>
                  {option.select}
                </option>
              ))}
            </select>
          </div>
        </div>
      )
    case 'select-multiple':
      return (
        <div className='mt-6'>
          {label && <label className='form-label fw-normal'>{label}</label>}
          <div>
            <select
              className='form-select fw-normal ps-4 pe-12 border border-hover-primary'
              data-kt-select2='true'
              data-placeholder='Select option'
              data-allow-clear='true'
              value={value}
              onChange={(event) => change(event.target.value)}
              multiple
            >
              {options.map((option: any) => (
                <option key={option.value} value={option.value}>
                  {option.select}
                </option>
              ))}
            </select>
          </div>
        </div>
      )
    case 'search':
      return (
        <div className='d-flex align-items-center border border-hover-primary px-3 rounded mt-6'>
          <i className='fas fa-search'></i>
          <input
            className='border-0 w-100 form-control'
            type='text'
            placeholder={placeholder}
            value={value}
            onBlur={(event: any) => blur && blur(event.target.value)}
            onChange={(event) => change(event.target.value)}
            onKeyDown={(event: any) => {
              if (event.key === 'Enter') {
                event.target.blur()
              } else {
                if (onKeyDown) onKeyDown(event.key)
              }
            }}
          />
        </div>
      )
    case 'date':
      return (
        <div className='mt-6'>
          {label && <label className='form-label fw-normal'>{label}</label>}
          <div className='d-flex align-items-center border border-hover-primary px-3 rounded'>
            <input
              className='border-0 w-100 form-control fw-normal'
              type='date'
              placeholder={placeholder}
              value={value}
              onChange={(event) => change(event.target.value)}
              min={minLength}
              max={maxLength}
            />
          </div>
        </div>
      )
    case 'datetime-local':
      return (
        <div className='mt-6'>
          {label && <label className='form-label fw-normal'>{label}</label>}
          <div className='d-flex align-items-center border border-hover-primary px-3 rounded'>
            <InputMask
              className='border-0 w-100 form-control fw-normal'
              mask='99/99/9999 99:99'
              placeholder={placeholder || 'DD/MM/YYYY HH:MM'}
              value={value}
              onChange={(event: any) => change(event.target.value)}
              onBlur={(event: any) => blur && blur(event.target.value)}
            />
          </div>
        </div>
      )
    case 'email':
      return (
        <div className={`${marginTop ? marginTop : 'mt-6'} ${grow ? 'flex-grow-1' : ``}`}>
          {label && (
            <label className={`form-label fw-normal ${required ? 'required' : ''}`}>{label}</label>
          )}
          <div className='d-flex align-items-center border border-hover-primary rounded'>
            <input
              className='border-0 w-100 form-control fw-normal'
              type='email'
              placeholder={placeholder}
              value={value}
              onChange={(event) => change(removeEspacosEmBranco(event.target.value))}
            />
          </div>
        </div>
      )
    case 'number':
      return (
        <div className={`${marginTop ? marginTop : 'mt-6'} ${grow ? 'flex-grow-1' : ``}`}>
          {label && (
            <label
              className={`form-label fw-normal ${required ? 'required' : ''}`}
              style={{display: 'inline-flex', alignItems: 'center', gap: 6}}
            >
              {label}
              {toolTip && <MyTooltip text={toolTiptext!} icon={toolTipIcon} link={toolTipLink} />}
            </label>
          )}
          <div className={` d-flex align-items-center border border-hover-primary rounded`}>
            <input
              className={
                textCenter
                  ? 'border-0 w-100 form-control fw-normal text-center'
                  : 'border-0 w-100 form-control fw-normal'
              }
              type='number'
              disabled={disabled}
              placeholder={placeholder}
              value={value}
              onBlur={(event: any) => blur && blur(event.target.value)}
              onChange={(event) => {
                if (minNumber && !maxNumber && minNumber <= parseInt(event.target.value)) {
                  change(event.target.value)
                } else if (maxNumber && !minNumber && maxNumber >= parseInt(event.target.value)) {
                  change(event.target.value)
                } else if (
                  maxNumber &&
                  minNumber &&
                  maxNumber >= parseInt(event.target.value) &&
                  minNumber <= parseInt(event.target.value)
                ) {
                  change(event.target.value)
                } else if (!maxNumber && !maxNumber) {
                  change(event.target.value)
                } else if (!event.target.value) {
                  change(event.target.value)
                }
              }}
              max={maxNumber}
              min={minNumber}
            />
          </div>
        </div>
      )
    case 'number-agregador':
      return (
        <div className={`${vertical ? 'd-flex align-items-center gap-4' : ''}`}>
          {label && <label className='form-label fw-normal'>{label}</label>}
          <div className='d-flex align-items-center border border-hover-primary rounded'>
            <input
              className={
                textCenter
                  ? 'border-0  form-control fw-normal text-center'
                  : 'border-0  form-control fw-normal'
              }
              style={{
                height: height ? `${height}px` : '',
                width: width ? `${width}px` : '',
              }}
              type='number'
              disabled={disabled}
              placeholder={placeholder}
              value={value}
              onBlur={(event: any) => blur && blur(event.target.value)}
              onChange={(event) => {
                if (minNumber && !maxNumber && minNumber <= parseInt(event.target.value)) {
                  change(event.target.value)
                } else if (maxNumber && !minNumber && maxNumber >= parseInt(event.target.value)) {
                  change(event.target.value)
                } else if (
                  maxNumber &&
                  minNumber &&
                  maxNumber >= parseInt(event.target.value) &&
                  minNumber <= parseInt(event.target.value)
                ) {
                  change(event.target.value)
                } else if (!maxNumber && !maxNumber) {
                  change(event.target.value)
                } else if (!event.target.value) {
                  change(event.target.value)
                }
              }}
              max={maxNumber}
              min={minNumber}
            />
            {toolTip && <MyTooltip text={toolTiptext!} icon={toolTipIcon} link={toolTipLink} />}
          </div>
        </div>
      )
    case 'smallNumber':
      return (
        <div className={`${height ? `h-${height}px` : ''} ${width ? `w-${width}px` : ''}`}>
          {label && <label className='form-label fw-normal'>{label}</label>}
          <div className='d-flex align-items-center border border-hover-primary rounded'>
            <input
              className={
                textCenter
                  ? 'border-0 w-100 fw-normal text-center form-control'
                  : 'border-0 w-100  fw-normal form-control'
              }
              style={{
                height: height ? `${height}px` : '',
                width: width ? `${width}px` : '',
              }}
              type='number'
              disabled={disabled}
              placeholder={placeholder}
              value={value}
              onBlur={(event: any) => blur && blur(event.target.value)}
              onChange={(event) => {
                if (minNumber && !maxNumber && minNumber <= parseInt(event.target.value)) {
                  change(event.target.value)
                } else if (maxNumber && !minNumber && maxNumber >= parseInt(event.target.value)) {
                  change(event.target.value)
                } else if (
                  maxNumber &&
                  minNumber &&
                  maxNumber >= parseInt(event.target.value) &&
                  minNumber <= parseInt(event.target.value)
                ) {
                  change(event.target.value)
                } else if (!maxNumber && !maxNumber) {
                  change(event.target.value)
                } else if (!event.target.value) {
                  change(event.target.value)
                }
              }}
              max={maxNumber}
              min={minNumber}
            />
            {toolTip && <MyTooltip text={toolTiptext!} icon={toolTipIcon} link={toolTipLink} />}
          </div>
        </div>
      )
    case 'tel':
      return (
        <div className='mt-6'>
          {label && (
            <label className={`form-label fw-normal ${required ? 'required' : ''}`}>{label}</label>
          )}
          <div className='d-flex flex-grow-1 align-items-center border border-hover-primary rounded'>
            <InputMask
              className='border-0 w-100 form-control fw-normal'
              mask={maskTelephone}
              placeholder={placeholder}
              value={value}
              onBeforeInput={(event: any) => changePhone(event.currentTarget.value, event.data)}
              onChange={(event: any) => {
                changePhone(event.currentTarget.value, event.data)
                change(event.target.value)
              }}
            />
          </div>
        </div>
      )
    case 'money':
      return (
        <div className={`${marginTop ? marginTop : 'mt-6'} flex-grow-1`}>
          {label && <label className='form-label fw-normal'>{label}</label>}
          <div
            className='d-flex flex-grow-1 align-items-center border-hover-primary rounded grow-1'
            style={{
              border: alarm ? '1px solid #d90429' : '1px solid #eff2f5',
            }}
          >
            <IntlCurrencyInput
              className='border-0 w-100 form-control fw-normal'
              currency={currency}
              config={{
                locale: locale,
                formats: {
                  number: {
                    BRL: {
                      style: 'currency',
                      currency: currency,
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    },
                  },
                },
              }}
              onChange={(event: any, value: number, maskedValue: string) => change(value)}
              value={value}
              onBlur={(event: any) => blur && blur(event.target.value)}
              disabled={disabled}
            />
          </div>
          {alarm && <p className='mt-1 text-danger'>{alarmText ? alarmText : 'Campo faltante'}</p>}
        </div>
      )
    case 'time':
      return (
        <div className='mt-6'>
          {label && <label className='form-label fw-normal'>{label}</label>}
          {/* eslint-disable eqeqeq */}
          <div
            className={`d-flex align-items-center border border-hover-primary rounded ${
              size ? (size == 'sm' ? 'w-50' : 'w-75') : 'w-100'
            } ${size ? (size == 'sm' ? 'px-1' : '') : 'px-3'}`}
          >
            <InputMask
              className={`border-0 ${
                size ? (size == 'sm' ? 'w-75' : 'w-100') : 'w-100'
              } form-control fw-normal text-center`}
              mask='99:99:99'
              placeholder={placeholder}
              value={value}
              onChange={(event: any) => change(event.target.value)}
              onBlur={(event: any) => blur && blur(event.target.value)}
              disabled={disabled}
            />
          </div>
          {/* eslint-enable eqeqeq */}
        </div>
      )
    case 'hour':
      return (
        <div className='mt-6'>
          {label && <label className='form-label fw-normal'>{label}</label>}
          {/* eslint-disable eqeqeq */}
          <div
            className={`d-flex align-items-center border border-hover-primary rounded ${
              size ? (size == 'sm' ? 'w-50' : 'w-75') : ''
            } ${size ? (size == 'sm' ? 'px-1' : '') : 'px-3'}`}
          >
            <InputMask
              // eslint-disable-next-line eqeqeq
              className={`border-0 ${
                size ? (size == 'sm' ? 'w-75' : 'w-100') : 'w-100'
              } form-control fw-normal text-center`}
              mask='99:99'
              placeholder={placeholder}
              value={value}
              onChange={(event: any) => change(event.target.value)}
              onBlur={(event: any) => blur && blur(event.target.value)}
              disabled={disabled}
            />
            {toolTip && <MyTooltip text={toolTiptext!} icon={toolTipIcon} link={toolTipLink} />}
          </div>
          {/* eslint-enable eqeqeq */}
        </div>
      )
    case 'cnpj':
      return (
        <div className='mt-6'>
          {label && <label className='form-label fw-normal'>{label}</label>}
          <div className='d-flex align-items-center border border-hover-primary rounded'>
            <InputMask
              className='border-0 w-100 form-control fw-normal'
              mask='99.999.999/9999-99'
              placeholder={placeholder}
              aria-disabled={disabled}
              value={value}
              onChange={(event: any) => change(event.target.value)}
              disabled={disabled}
            />
          </div>
        </div>
      )
    case 'cep':
      return (
        <div className='mt-6'>
          {label && <label className='form-label fw-normal'>{label}</label>}
          <div className='d-flex align-items-center border border-hover-primary rounded'>
            <InputMask
              className='border-0 w-100 form-control fw-normal'
              mask='99999-999'
              placeholder={placeholder}
              value={value}
              onChange={(event: any) => change(event.target.value)}
              onBlur={(event: any) => blur && blur(event.target.value)}
            />
          </div>
        </div>
      )
    case 'cpf':
      return (
        <div className='mt-6'>
          {label && <label className='form-label fw-normal'>{label}</label>}
          <div className='d-flex align-items-center border border-hover-primary rounded'>
            <InputMask
              className='border-0 w-100 form-control fw-normal'
              mask='999.999.999-99'
              placeholder={placeholder}
              aria-disabled={disabled}
              value={value}
              onChange={(event: any) => change(event.target.value)}
              onBlur={(event: any) => blur && blur(event.target.value)}
            />
          </div>
        </div>
      )
    case 'color':
      return (
        <div className='mt-6'>
          {label && <label className='form-label fw-normal'>{label}</label>}
          <div className='d-flex min-w-150px align-items-center border border-hover-primary rounded'>
            <input
              className='border-0 w-100 form-control fw-normal'
              type='color'
              value={value}
              onChange={(event) => change(event.target.value)}
            />
          </div>
        </div>
      )

    case 'smallColor':
      return (
        <div className='mt-1'>
          {label && (
            <label className='form-label' style={{fontSize: '11px', lineHeight: '9px'}}>
              {label}
            </label>
          )}
          <div className='d-flex min-w-150px align-items-center border border-hover-primary rounded'>
            <input
              className='border-0 w-100 form-control fw-normal'
              type='color'
              value={value}
              onChange={(event) => change(event.target.value)}
            />
          </div>
        </div>
      )
    case 'textarea':
      return (
        <div className={`${marginTop ? marginTop : 'mt-6'}`}>
          {label && (
            <label className='form-label fw-normal'>
              {label} <small>{smalltext}</small>
            </label>
          )}
          <div className='d-flex flex-column gap-2'>
            <div className='d-flex min-w-150px align-items-center border border-hover-primary rounded'>
              <textarea
                className='border-0 w-100 form-control fw-normal'
                style={{
                  background: backgroundColor,
                }}
                value={value}
                placeholder={placeholder}
                maxLength={maxCaracteres}
                rows={rows}
                disabled={disabled}
                onChange={(event) => change(event.target.value)}
                id={`${idInput ? idInput : label}`}
              ></textarea>
            </div>
            {generateValueIA &&
              (loadingButton ? (
                <ReactLoading type='spin' color='#D5D5D5' height={25} width={25} />
              ) : (
                <div style={{maxWidth: '40%'}}>
                  <Button
                    text={`${i18n.t(`buttons.generate_ia`)} ${label ? label.toLowerCase() : ''}`}
                    color='info'
                    size='small'
                    horizontalPadding={5}
                    btnAttr={{
                      type: 'button',
                    }}
                    svgIcon={
                      <svg
                        width='15'
                        height='15'
                        viewBox='0 0 15 15'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          d='M6.39844 1.92578L6.78125 0.886719C6.80859 0.804688 6.89062 0.75 7 0.75C7.08203 0.75 7.16406 0.804688 7.19141 0.886719L7.57422 1.92578L8.61328 2.30859C8.69531 2.33594 8.75 2.41797 8.75 2.5C8.75 2.60938 8.69531 2.69141 8.61328 2.71875L7.57422 3.10156L7.19141 4.11328C7.16406 4.19531 7.08203 4.25 7 4.25C6.89062 4.25 6.80859 4.19531 6.78125 4.11328L6.39844 3.10156L5.38672 2.71875C5.30469 2.69141 5.25 2.60938 5.25 2.5C5.25 2.41797 5.30469 2.33594 5.38672 2.30859L6.39844 1.92578ZM12.6055 2.0625L9.59766 5.07031L10.5547 6.02734L13.5625 3.01953L12.6055 2.0625ZM2.1875 12.5078L3.11719 13.4375L9.625 6.95703L8.66797 6L2.1875 12.5078ZM11.6758 1.16016C12.1953 0.640625 13.0156 0.640625 13.5352 1.16016L14.4648 2.08984C14.9844 2.60938 14.9844 3.42969 14.4648 3.94922L4.04688 14.3672C3.52734 14.8867 2.70703 14.8867 2.1875 14.3672L1.25781 13.4375C0.738281 12.918 0.738281 12.0977 1.25781 11.5781L11.6758 1.16016ZM0.191406 3.97656L1.75 3.375L2.32422 1.84375C2.35156 1.70703 2.48828 1.625 2.625 1.625C2.73438 1.625 2.87109 1.70703 2.89844 1.84375L3.5 3.375L5.03125 3.97656C5.16797 4.00391 5.25 4.14062 5.25 4.25C5.25 4.38672 5.16797 4.52344 5.03125 4.55078L3.5 5.125L2.89844 6.68359C2.87109 6.79297 2.73438 6.875 2.625 6.875C2.48828 6.875 2.35156 6.79297 2.32422 6.68359L1.75 5.125L0.191406 4.55078C0.0820312 4.52344 0 4.38672 0 4.25C0 4.14062 0.0820312 4.00391 0.191406 3.97656ZM9.81641 10.9766L11.375 10.375L11.9492 8.84375C11.9766 8.70703 12.1133 8.625 12.25 8.625C12.3594 8.625 12.4961 8.70703 12.5234 8.84375L13.125 10.375L14.6562 10.9766C14.793 11.0039 14.875 11.1406 14.875 11.25C14.875 11.3867 14.793 11.5234 14.6562 11.5508L13.125 12.125L12.5234 13.6836C12.4961 13.793 12.3594 13.875 12.25 13.875C12.1133 13.875 11.9766 13.793 11.9492 13.6836L11.375 12.125L9.81641 11.5508C9.70703 11.5234 9.625 11.3867 9.625 11.25C9.625 11.1406 9.70703 11.0039 9.81641 10.9766Z'
                          fill='white'
                        />
                      </svg>
                    }
                    click={async () => {
                      setLoadingButton(true)
                      await generateTextIA()
                      setLoadingButton(false)
                    }}
                    btnClass='fw-bolder me-3 d-flex flex-row gap-2 align-items-center'
                    txtClass='text-nowrap'
                  />
                </div>
              ))}
          </div>
        </div>
      )
    case 'password':
      return (
        <div className='mt-6 flex-grow-1'>
          {label && <label className='form-label fw-normal'>{label}</label>}
          <div className='d-flex align-items-center border border-hover-primary rounded'>
            <input
              className='border-0 w-100 form-control fw-normal'
              type={hiddenPassword ? 'password' : 'default'}
              placeholder={placeholder}
              value={value}
              onChange={(event) => change(removeEspacosEmBranco(event.target.value))}
              disabled={disabled}
              autoComplete={autoComplete}
              onKeyDown={(event) => onKeyDown && onKeyDown(event.key)}
            />
            {hiddenPassword ? (
              <i
                style={{color: '#ccc', fontSize: 20, paddingRight: 12}}
                className='bi bi-eye-fill cursor-pointer text-hover-primary'
                onClick={() => setHiddenPassword(!hiddenPassword)}
              ></i>
            ) : (
              <i
                style={{color: '#ccc', fontSize: 20, paddingRight: 12}}
                className='bi bi-eye-slash-fill cursor-pointer text-hover-primary'
                onClick={() => setHiddenPassword(!hiddenPassword)}
              ></i>
            )}
          </div>
        </div>
      )
    case 'file':
      return (
        <div>
          {id ? (
            <input
              id={id}
              type='file'
              name='file'
              accept={acceptFile ? acceptFile : ''}
              onChange={(event) => change(event)}
              value={value}
            />
          ) : (
            <input
              type='file'
              name='file'
              accept={acceptFile ? acceptFile : ''}
              onChange={(event) => change(event)}
              value={value}
            />
          )}
        </div>
      )
    case 'image':
      return (
        <div
          className={`d-flex flex-row gap-6 align-items-end ${paddingLeft ? paddingLeft : 'p-4'} ${
            marginTop ? marginTop : ''
          }`}
          style={{flexWrap: 'wrap'}}
        >
          <div>
            {label && <label className='form-label fw-normal'>{label}</label>}
            <div
              className={`${styles.image_container} mt-1 ${width ? `w-${width}px` : 'w-150px'} ${
                value ? '' : styles.bgImgContainer
              }`}
            >
              <div
                className={`${width ? `w-${width}px` : 'w-150px'} ${
                  height ? `h-${height}px` : 'h-150px'
                } rounded `}
                style={imageBackgroundColor ? {backgroundColor: imageBackgroundColor} : {}}
              >
                <img
                  className='w-100 h-100 rounded'
                  style={{objectFit: objectFit}}
                  src={
                    value
                      ? typeof value === 'string'
                        ? value
                        : value instanceof Blob
                        ? URL.createObjectURL(value)
                        : imagemBackgroundDefault
                        ? `https://placehold.co/${imagemBackgroundDefault}`
                        : `https://placehold.co/640x640`
                      : imagemBackgroundDefault
                      ? `https://placehold.co/${imagemBackgroundDefault}`
                      : `https://placehold.co/640x640`
                  }
                  alt=''
                />
              </div>
              <label
                className={`${styles.icon_edit} btn btn-xs btn-icon rounded-circle btn-white btn-hover-text-primary shadow`}
                data-action='change'
                data-toggle='tooltip'
                title='Trocar'
              >
                <i className='fa fa-pen icon-sm text-muted'></i>
                <input
                  type='file'
                  accept='.jpg, .jpeg, .png, .gif'
                  name='file'
                  disabled={disabled}
                  className={`${styles.input_edit} custom-file-input opacity-0 w-0 h-0`}
                  onChange={(event) => change(event)}
                />
              </label>
              {!removeImage && (
                <span
                  className={`${styles.icon_remove} btn btn-xs btn-icon rounded-circle btn-white btn-hover-text-primary shadow`}
                  data-action='remove'
                  data-toggle='tooltip'
                  title='Remover'
                  onClick={() => change(null)}
                >
                  <i className='bi bi-x text-muted fs-1'></i>
                </span>
              )}
            </div>
          </div>
          {generateValueIA && (
            <div style={{height: '20%'}}>
              <Button
                text={i18n.t(`buttons.propose_image`)}
                color='info'
                size='small'
                horizontalPadding={5}
                btnAttr={{
                  type: 'button',
                }}
                svgIcon={
                  <svg
                    width='15'
                    height='15'
                    viewBox='0 0 15 15'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M6.39844 1.92578L6.78125 0.886719C6.80859 0.804688 6.89062 0.75 7 0.75C7.08203 0.75 7.16406 0.804688 7.19141 0.886719L7.57422 1.92578L8.61328 2.30859C8.69531 2.33594 8.75 2.41797 8.75 2.5C8.75 2.60938 8.69531 2.69141 8.61328 2.71875L7.57422 3.10156L7.19141 4.11328C7.16406 4.19531 7.08203 4.25 7 4.25C6.89062 4.25 6.80859 4.19531 6.78125 4.11328L6.39844 3.10156L5.38672 2.71875C5.30469 2.69141 5.25 2.60938 5.25 2.5C5.25 2.41797 5.30469 2.33594 5.38672 2.30859L6.39844 1.92578ZM12.6055 2.0625L9.59766 5.07031L10.5547 6.02734L13.5625 3.01953L12.6055 2.0625ZM2.1875 12.5078L3.11719 13.4375L9.625 6.95703L8.66797 6L2.1875 12.5078ZM11.6758 1.16016C12.1953 0.640625 13.0156 0.640625 13.5352 1.16016L14.4648 2.08984C14.9844 2.60938 14.9844 3.42969 14.4648 3.94922L4.04688 14.3672C3.52734 14.8867 2.70703 14.8867 2.1875 14.3672L1.25781 13.4375C0.738281 12.918 0.738281 12.0977 1.25781 11.5781L11.6758 1.16016ZM0.191406 3.97656L1.75 3.375L2.32422 1.84375C2.35156 1.70703 2.48828 1.625 2.625 1.625C2.73438 1.625 2.87109 1.70703 2.89844 1.84375L3.5 3.375L5.03125 3.97656C5.16797 4.00391 5.25 4.14062 5.25 4.25C5.25 4.38672 5.16797 4.52344 5.03125 4.55078L3.5 5.125L2.89844 6.68359C2.87109 6.79297 2.73438 6.875 2.625 6.875C2.48828 6.875 2.35156 6.79297 2.32422 6.68359L1.75 5.125L0.191406 4.55078C0.0820312 4.52344 0 4.38672 0 4.25C0 4.14062 0.0820312 4.00391 0.191406 3.97656ZM9.81641 10.9766L11.375 10.375L11.9492 8.84375C11.9766 8.70703 12.1133 8.625 12.25 8.625C12.3594 8.625 12.4961 8.70703 12.5234 8.84375L13.125 10.375L14.6562 10.9766C14.793 11.0039 14.875 11.1406 14.875 11.25C14.875 11.3867 14.793 11.5234 14.6562 11.5508L13.125 12.125L12.5234 13.6836C12.4961 13.793 12.3594 13.875 12.25 13.875C12.1133 13.875 11.9766 13.793 11.9492 13.6836L11.375 12.125L9.81641 11.5508C9.70703 11.5234 9.625 11.3867 9.625 11.25C9.625 11.1406 9.70703 11.0039 9.81641 10.9766Z'
                      fill='white'
                    />
                  </svg>
                }
                click={action ? action : () => {}}
                btnClass='fw-bolder me-3 d-flex flex-row gap-2 align-items-center'
                txtClass='text-nowrap'
              />
            </div>
          )}
        </div>
      )

    case 'image_modal':
      return (
        <div>
          {label && <label className='form-label fw-normal'>{label}</label>}
          <div
            className={`${styles.image_container} mt-1 ${width ? `w-${width}px` : 'w-150px'} ${
              value ? '' : styles.bgImgContainer
            }`}
          >
            <div
              className={`${width ? `w-${width}px` : 'w-150px'} ${
                height ? `h-${height}px` : 'h-150px'
              } rounded`}
            >
              <img
                className='w-100 h-100 rounded'
                src={
                  value
                    ? typeof value === 'string'
                      ? value
                      : value instanceof Blob
                      ? URL.createObjectURL(value)
                      : imagemBackgroundDefault
                      ? `https://placehold.co/${imagemBackgroundDefault}`
                      : 'https://placehold.co/640x640'
                    : imagemBackgroundDefault
                    ? `https://placehold.co/${imagemBackgroundDefault}`
                    : 'https://placehold.co/640x640'
                }
                alt='Logo pluginspace'
              />
            </div>
            <label
              className={`${styles.icon_edit} btn btn-xs btn-icon rounded-circle btn-white btn-hover-text-primary shadow`}
              data-action='change'
              data-toggle='tooltip'
              title='Trocar'
              onClick={() => action && action()}
            >
              <i className='fa fa-pen icon-sm text-muted'></i>
            </label>
            <span
              className={`${styles.icon_remove} btn btn-xs btn-icon rounded-circle btn-white btn-hover-text-primary shadow`}
              data-action='remove'
              data-toggle='tooltip'
              title='Remover'
              onClick={() => change(null)}
            >
              <i className='bi bi-x text-muted fs-1'></i>
            </span>
          </div>
        </div>
      )
    case 'image-agregador':
      return (
        <div>
          {label && <label className='form-label fw-normal'>{label}</label>}
          <div
            className={`${styles.image_container} mt-1 ${width ? `w-${width}px` : 'w-150px'} ${
              value ? '' : styles.bgImgContainer
            }`}
          >
            <div
              className={`${width ? `w-${width}px` : 'w-150px'} ${
                height ? `h-${height}px` : 'h-150px'
              } rounded`}
            >
              <img
                className='w-100 h-100 rounded'
                src={
                  value
                    ? typeof value === 'string'
                      ? value
                      : value instanceof Blob
                      ? URL.createObjectURL(value)
                      : imagemBackgroundDefault
                      ? `https://placehold.co/${imagemBackgroundDefault}`
                      : 'https://placehold.co/640x640'
                    : imagemBackgroundDefault
                    ? `https://placehold.co/${imagemBackgroundDefault}`
                    : 'https://placehold.co/640x640'
                }
                alt='Logo pluginspace'
              />
            </div>
            {/* <label
            className={`${styles.icon_edit} btn btn-xs btn-icon rounded-circle btn-white btn-hover-text-primary shadow`}
            data-action='change'
            data-toggle='tooltip'
            title='Trocar'
          >
            <i className='fa fa-pen icon-sm text-muted'></i>
            <input
              type='file'
              accept='.jpg, .jpeg, .png, .gif'
              name='file'
              disabled={disabled}
              className={`${styles.input_edit} custom-file-input opacity-0 w-0 h-0`}
              onChange={(event) => change(event)}
            />
          </label> */}
          </div>
        </div>
      )
    case 'icon':
      return (
        <div>
          {label && <label className='form-label fw-normal'>{label}</label>}
          <div
            className={`${styles.image_container} mt-1 w-150px ${
              value ? '' : styles.bgImgContainer
            }`}
          >
            <div
              className={`${width ? `w-${width}px` : 'w-150px'} ${
                height ? `h-${height}px` : 'h-150px'
              } rounded`}
            >
              {value && value.svg ? (
                <SVG
                  src={value?.svg}
                  style={{
                    width: '140px',
                    height: '140px',
                  }}
                />
              ) : (
                <img
                  className='w-100 h-100 rounded'
                  src={
                    value
                      ? typeof value === 'string'
                        ? value
                        : value instanceof Blob
                        ? URL.createObjectURL(value)
                        : imagemBackgroundDefault
                        ? `https://placehold.co/${imagemBackgroundDefault}`
                        : 'https://placehold.co/640x640'
                      : imagemBackgroundDefault
                      ? `https://placehold.co/${imagemBackgroundDefault}`
                      : 'https://placehold.co/640x640'
                  }
                  alt='Logo pluginspace'
                />
              )}
            </div>
            <label
              className={`${styles.icon_edit} btn btn-xs btn-icon rounded-circle btn-white btn-hover-text-primary shadow`}
              data-action='change'
              data-toggle='tooltip'
              title='Trocar'
            >
              <i
                className='fa fa-pen icon-sm text-muted'
                onClick={() => {
                  onAction && onAction()
                }}
              ></i>
            </label>
            <span
              className={`${styles.icon_remove} btn btn-xs btn-icon rounded-circle btn-white btn-hover-text-primary shadow`}
              data-action='remove'
              data-toggle='tooltip'
              title='Remover'
              onClick={() => change(null)}
            >
              <i className='bi bi-x text-muted fs-1'></i>
            </span>
          </div>
        </div>
      )
    case 'link':
      return (
        <div className='d-flex gap-2 mt-2'>
          {label && (
            <span
              style={{
                color: '#888C9F',
                opacity: '50%',
              }}
            >
              {label}
            </span>
          )}
          <div style={{position: 'relative', display: 'inline-block', gap: '4px'}}>
            <i
              className='bi bi-link-45deg'
              style={{
                position: 'absolute',
                left: '3px',
                top: '50%',
                transform: 'translateY(-50%)',
                pointerEvents: 'none',
              }}
            ></i>
            <input
              style={{
                borderRadius: '6px',
                borderWidth: '1px',
                height: '20px',
                borderColor: '#D8D8D8',
                borderStyle: 'solid',
                paddingLeft: '18px',
                outline: 'none',
              }}
              type='text'
              value={value}
              onChange={(event) => change(event.target.value)}
              onBlur={(event: any) => blur && blur(event.target.value)}
            />
          </div>
        </div>
      )

    case 'link-agregador':
      return (
        <div className='d-flex gap-2 mt-4 align-itens-center'>
          {label && (
            <span
              style={{
                color: '#888C9F',
                opacity: '50%',
              }}
            >
              {label}
            </span>
          )}
          <div style={{position: 'relative', display: 'inline-block', gap: '4px'}}>
            <i
              className='bi bi-link-45deg'
              style={{
                position: 'absolute',
                left: '3px',
                top: '50%',
                transform: 'translateY(-50%)',
                pointerEvents: 'none',
              }}
            ></i>
            <input
              style={{
                borderRadius: '6px',
                borderWidth: '1px',
                height: '30px',
                width: '400px',
                borderColor: '#D8D8D8',
                borderStyle: 'solid',
                paddingLeft: '18px',
                outline: 'none',
              }}
              type='text'
              value={value}
              disabled={disabled}
              onChange={(event) => change(event.target.value)}
              onBlur={(event: any) => blur && blur(event.target.value)}
            />
          </div>
        </div>
      )
    case 'string':
      return (
        <div className={`${marginTop ? marginTop : 'mt-6'} flex-grow-1`}>
          {label && (
            <label className='form-label fw-normal'>
              {label} <small>{smalltext}</small>
            </label>
          )}
          <div
            className='d-flex align-items-center border-hover-primary rounded w-100'
            style={alarm ? {border: '1px solid #d90429'} : {border: '1px solid #eff2f5'}}
          >
            <input
              className={`border-0 w-100 form-control fw-normal ${
                textCenter ? 'text-center' : ''
              } ${secret && !isFieldFocused ? styles.blur_on_lose_focus : ''}`}
              type='text'
              placeholder={placeholder}
              value={getDisplayValue()}
              maxLength={maxCaracteres}
              onChange={(event) => {
                const newValue = event.target.value
                if (secret) {
                  handleSecretChange(newValue)
                } else {
                  onlyLetters ? onlyLettersInput(event) : change(newValue)
                }
              }}
              disabled={disabled}
              name={name}
              autoFocus={focus}
              onFocus={secret ? handleSecretFocus : undefined}
              onBlur={secret ? handleSecretBlur : (event) => blur && blur(event.target.value)}
            />
          </div>
        </div>
      )
    case 'multiselect':
      return (
        <div className={`${marginTop ? marginTop : 'mt-6'} flex-grow-1`}>
          {label && (
            <label className='form-label fw-normal'>
              {label}
              {toolTip && <MyTooltip text={toolTiptext!} icon={toolTipIcon} link={toolTipLink} />}
            </label>
          )}
          <div style={{border: alarm ? '1px solid #d90429' : 'none', borderRadius: '0.5rem'}}>
            <Select
              styles={{
                valueContainer: (provided, state) => ({
                  ...provided,
                  flexWrap: 'wrap',
                  maxHeight: 80,
                  overflowY: 'auto',
                }),
                multiValue: (provided, state) => ({
                  ...provided,
                  maxWidth: '100%',
                  whiteSpace: 'normal',
                }),
                control: (provided, state) => ({
                  ...provided,
                  minHeight: '38px',
                  maxHeight: '120px',
                  overflowY: 'auto',
                }),
              }}
              value={value}
              isMulti={true}
              onChange={(event) => change(event)}
              placeholder={placeholder ? placeholder : 'Selecione uma opção'}
              options={options.map((option: any) => ({
                value: option.value,
                label: option.select,
              }))}
              isDisabled={disabled ? disabled : false}
            />
            {smalltext && <small className='mt-2'>{smalltext}</small>}
          </div>
          {alarm && <p className='mt-1 text-danger'>{alarmText ? alarmText : 'Campo faltante'}</p>}
        </div>
      )
    case 'image-upload':
      return (
        <ImageUpload
          label={label}
          onChange={change}
          iconImage={iconImage}
          mainTextImage={mainTextImage}
          descriptionImage={descriptionImage}
          sizeImage={sizeImage}
          dragAndDropImage={dragAndDropImage}
          verticalAlign={verticalAlign}
          maxFiles={maxFiles}
        />
      )
    case 'image-upload-edit':
      return (
        <ImageUploadEdit
          label={label}
          value={value}
          onChange={change}
          setImagesToDelete={setImagesToDelete}
          imagesToDelete={imagesToDelete}
          iconImage={iconImage}
          mainTextImage={mainTextImage}
          descriptionImage={descriptionImage}
          sizeImage={sizeImage}
          dragAndDropImage={dragAndDropImage}
          verticalAlign={verticalAlign}
          maxFiles={maxFiles}
        />
      )
    case 'slider':
      const min = minNumber ?? 0
      const max = maxNumber ?? 30
      const valNum = Number(value) // se value vier string, converta
      const percent = ((valNum - min) / (max - min)) * 100
      return (
        <div className='mt-4'>
          {label && <label className='form-label fw-normal'>{label}</label>}

          <div className='border border-1 border-secondary rounded-2 ps-4 pe-5 pt-2 pb-5'>
            {textToSlider && (
              <p className='mt-2'>
                {value}
                {textToSlider}
              </p>
            )}
            <input
              type='range'
              min={min}
              max={max}
              value={value}
              onChange={(event) => {
                const v = Number(event.target.value)
                change(v)
              }}
              disabled={disabled}
              className='form-range'
              style={
                {
                  // TIPAGEM TS: React.CSSProperties não “conhece” props customizadas,
                  // então use Record<string, string>
                  ['--percent' as any]: `${percent}%`,
                  ['--before-color' as any]: colorBefore ?? '#aac2fdff',
                  ['--after-color' as any]: colorAfter ?? '#e4e6ef',
                } as React.CSSProperties
              }
            />

            <div className='d-flex justify-content-between'>
              <span>
                {minNumber ?? 0}
                {textToSlider ? textToSlider : ''} {textToMinNumber ? textToMinNumber : ''}
              </span>
              <span>
                {maxNumber ?? 30}
                {textToSlider ? textToSlider : ''} {textToMaxNumber ? textToMaxNumber : ''}
              </span>
            </div>
          </div>
        </div>
      )

    default:
      return (
        <div className={`${marginTop ? marginTop : 'mt-6'} flex-grow-1`}>
          {label && (
            <label className={`form-label fw-normal ${required ? 'required' : ''}`}>
              {label} <small>{smalltext}</small>
            </label>
          )}
          <div className='d-flex flex-column gap-2'>
            <div
              className='d-flex align-items-center border-hover-primary rounded w-100'
              style={{
                border: alarm ? '1px solid #d90429' : '1px solid #eff2f5',
                backgroundColor: disabled ? '#eff2f5' : 'transparent',
              }}
            >
              <input
                className={`border-0 w-100 form-control fw-normal ${
                  textCenter ? 'text-center' : ''
                } ${secret && !isFieldFocused ? styles.blur_on_lose_focus : ''}`}
                type='text'
                placeholder={placeholder}
                value={getDisplayValue()}
                maxLength={maxCaracteres}
                onChange={(event) => {
                  const newValue = event.target.value
                  if (secret) {
                    handleSecretChange(newValue)
                  } else {
                    change(newValue)
                  }
                }}
                disabled={disabled}
                name={name}
                defaultValue={defaultValue}
                autoFocus={focus}
                onFocus={secret ? handleSecretFocus : undefined}
                onBlur={
                  secret ? handleSecretBlur : (event: any) => blur && blur(event.target.value)
                }
              />
              {showCheckbox && (
                <div className='form-check ms-2'>
                  <input
                    className='form-check-input'
                    type='checkbox'
                    checked={checkedCheckbox}
                    onChange={(e) => onChangeCheckbox?.(e.target.checked)}
                    title='Sem número'
                  />
                </div>
              )}
              {toolTip && <MyTooltip text={toolTiptext!} icon={toolTipIcon} link={toolTipLink} />}
            </div>
            {generateValueIA &&
              (loadingButton ? (
                <ReactLoading type='spin' color='#D5D5D5' height={25} width={25} />
              ) : (
                <div style={{maxWidth: '40%'}}>
                  <Button
                    text={`${i18n.t(`buttons.generate_ia`)} ${label ? label.toLowerCase() : ''}`}
                    color='info'
                    size='small'
                    horizontalPadding={5}
                    btnAttr={{
                      type: 'button',
                    }}
                    svgIcon={
                      <svg
                        width='15'
                        height='15'
                        viewBox='0 0 15 15'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          d='M6.39844 1.92578L6.78125 0.886719C6.80859 0.804688 6.89062 0.75 7 0.75C7.08203 0.75 7.16406 0.804688 7.19141 0.886719L7.57422 1.92578L8.61328 2.30859C8.69531 2.33594 8.75 2.41797 8.75 2.5C8.75 2.60938 8.69531 2.69141 8.61328 2.71875L7.57422 3.10156L7.19141 4.11328C7.16406 4.19531 7.08203 4.25 7 4.25C6.89062 4.25 6.80859 4.19531 6.78125 4.11328L6.39844 3.10156L5.38672 2.71875C5.30469 2.69141 5.25 2.60938 5.25 2.5C5.25 2.41797 5.30469 2.33594 5.38672 2.30859L6.39844 1.92578ZM12.6055 2.0625L9.59766 5.07031L10.5547 6.02734L13.5625 3.01953L12.6055 2.0625ZM2.1875 12.5078L3.11719 13.4375L9.625 6.95703L8.66797 6L2.1875 12.5078ZM11.6758 1.16016C12.1953 0.640625 13.0156 0.640625 13.5352 1.16016L14.4648 2.08984C14.9844 2.60938 14.9844 3.42969 14.4648 3.94922L4.04688 14.3672C3.52734 14.8867 2.70703 14.8867 2.1875 14.3672L1.25781 13.4375C0.738281 12.918 0.738281 12.0977 1.25781 11.5781L11.6758 1.16016ZM0.191406 3.97656L1.75 3.375L2.32422 1.84375C2.35156 1.70703 2.48828 1.625 2.625 1.625C2.73438 1.625 2.87109 1.70703 2.89844 1.84375L3.5 3.375L5.03125 3.97656C5.16797 4.00391 5.25 4.14062 5.25 4.25C5.25 4.38672 5.16797 4.52344 5.03125 4.55078L3.5 5.125L2.89844 6.68359C2.87109 6.79297 2.73438 6.875 2.625 6.875C2.48828 6.875 2.35156 6.79297 2.32422 6.68359L1.75 5.125L0.191406 4.55078C0.0820312 4.52344 0 4.38672 0 4.25C0 4.14062 0.0820312 4.00391 0.191406 3.97656ZM9.81641 10.9766L11.375 10.375L11.9492 8.84375C11.9766 8.70703 12.1133 8.625 12.25 8.625C12.3594 8.625 12.4961 8.70703 12.5234 8.84375L13.125 10.375L14.6562 10.9766C14.793 11.0039 14.875 11.1406 14.875 11.25C14.875 11.3867 14.793 11.5234 14.6562 11.5508L13.125 12.125L12.5234 13.6836C12.4961 13.793 12.3594 13.875 12.25 13.875C12.1133 13.875 11.9766 13.793 11.9492 13.6836L11.375 12.125L9.81641 11.5508C9.70703 11.5234 9.625 11.3867 9.625 11.25C9.625 11.1406 9.70703 11.0039 9.81641 10.9766Z'
                          fill='white'
                        />
                      </svg>
                    }
                    click={async () => {
                      setLoadingButton(true)
                      await generateTextIA()
                      setLoadingButton(false)
                    }}
                    btnClass='fw-bolder me-3 d-flex flex-row gap-2 align-items-center'
                    txtClass='text-nowrap'
                  />
                </div>
              ))}
          </div>
          {alarm && <p className='mt-1 text-danger'>{alarmText ? alarmText : 'Campo faltante'}</p>}
        </div>
      )
  }
}

export {Input}
